import { combineReducers } from "redux"
import homeReducer from "./homeReducer"
import recoverReducer from "./recoverReducer"
import registerReducer from "./registerReducer"
import socialReducer from "./socialReducer"
import uploaderReducer from "./fileUploadingReducer"
import userInfoReducer from "./userInfoReducer"
import fileUploadingReducer from "./fileUploadingReducer"
import getDataReducer from "./getDataReducer"
import commentReducer from "./commentReducer"

import popUpReducer from "./popUpReducer"
import contactsReducer from "./contactsReducer"
import postAdminReducer from "../admin/reducers/reportAdminReducer"
import markAdminReducer from ".././admin/reducers/markAdminReducer"
import categoriesAdminReducer from ".././admin/reducers/categoriesAdminReducer"
import certificationAdminReducer from ".././admin/reducers/certificationAdminReducer"
import permissionsAdminReducer from ".././admin/reducers/permissionsAdminReducer"
import awardsAdminReducer from ".././admin/reducers/awardsAdminReducer"
import notificationsReducer from "./notificationsReducer"
import messagesReducer from "./messagesReducer"
import pqrsAdminReducer from "../admin/reducers/pqrsAdminReducer"
import colorsAdminReducer from "../admin/reducers/colorsAdminReducer"
import settingsReducer from "./settingsReducer"
import wareHouseReducer from "../admin/reducers/wareHouseReducer"
import productsReducerAdmin from "../admin/reducers/productsReducer"
import wineriesReducerAdmin from "../admin/reducers/wineriesRecucer"
import StreamReducer from "./StreamReducer"
import subWineriesReducer from "../admin/reducers/subWineriesReducer"
import categoriesReducerAdmin from "../admin/reducers/categoriesReducerAdmin"
import subcategoriesReducerAdmin from "./subcategoriesReducerAdmin"
import wineryBatchesReducer from "../admin/reducers/wineryBatchesReducer"
import productsReducer from "../admin/reducers/productsReducer"
import marketPlaceReducer from "./marketPlaceReducer"
import { franqusieeReducer } from "./franchisieeReducer"
import locationReducers from "./locationReducers"
import TransferReducer from "../admin/reducers/TransferReducer"
import campaignReducer from "../admin/reducers/campaignReducer"
import adminJobReducers from "../admin/reducers/adminJobReducers"
import adminCampaignReducer from "../admin/reducers/adminCampaignsReducer"
import adminAdvertinsingReducers from "../admin/reducers/adminAdvertinsingReducers"
import oilReducers from "./oilReducers"
import inventoryReducer from "./inventoryReducer"
import { chatSlice } from "../actions/slices/chat/chatSlice"



const appReducer = combineReducers({
  adminJobReducers: adminJobReducers,
  stream: StreamReducer,
  register: registerReducer,
  recover: recoverReducer,
  social: socialReducer,
  uploaderFile: uploaderReducer,
  home: homeReducer,
  userInfo: userInfoReducer,
  fileUpload: fileUploadingReducer,
  users: getDataReducer,
  comments: commentReducer,


  contacts: contactsReducer,
  postAdmin: postAdminReducer,
  markAdmin: markAdminReducer,
  socialCategoriesAdmin: categoriesAdminReducer,
  certificationAdmin: certificationAdminReducer,
  permissionsAdmin: permissionsAdminReducer,
  awardsAdmin: awardsAdminReducer,
  notifications: notificationsReducer,
  messages: messagesReducer,
  pqrsAdmin: pqrsAdminReducer,
  colorsReactionAdmin: colorsAdminReducer,
  settings: settingsReducer,
  WareHouse: wareHouseReducer,
  inventory: inventoryReducer,
  wineriesAdmin: wineriesReducerAdmin,
  subWineries: subWineriesReducer,
  categoriesAdmin: categoriesReducerAdmin,
  subCategoriesAdmin: subcategoriesReducerAdmin,
  wineryBatchesAdmin: wineryBatchesReducer,

  productsList: productsReducer,

  marketPlace: marketPlaceReducer,
  franchisee: franqusieeReducer,
  popUp: popUpReducer,
  locations: locationReducers,
  tranfers: TransferReducer,
  campaigns: campaignReducer,
  oil: oilReducers,
  adminCampaignsList: adminCampaignReducer,
  advertinsingReducers: adminAdvertinsingReducers,
  chat: chatSlice.reducer
})
const rootReducer = (state, action) => {
  if (action.type === 'USER_LOGOUT') {
    return appReducer(undefined, action)
  }

  return appReducer(state, action)
}
export default rootReducer;